import { render, staticRenderFns } from "./EditionsYear.vue?vue&type=template&id=0a30c5f8&"
import script from "./EditionsYear.vue?vue&type=script&lang=js&"
export * from "./EditionsYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports